<script>
export default {
  props: {
    type: {
      type: String,
      default: 'button',
    },
    to: {
      type: [Object, String],
      default: '',
    },
    href: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '_blank',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    toUpperCasefirst(str) {
      const strarr = str.split(' ')
      let result = ''

      for (let i in strarr) {
        result = `${strarr[i].substring(0, 1).toUpperCase()}${strarr[i].substring(1)}`
      }

      return result
    },
  },
}
</script>

<template>
  <a v-if="href" :href="href" :target="target" class="baseButton" :class="`isStyle${toUpperCasefirst(type)}`" v-on="$listeners">
    <span class="baseButton__content"><slot /></span>
  </a>
  <router-link v-else-if="to" :to="to" class="baseButton" :class="`isStyle${toUpperCasefirst(type)}`" v-on="$listeners">
    <span class="baseButton__content"><slot /></span>
  </router-link>
  <button v-else :type="type" class="baseButton" :class="[`isStyle${toUpperCasefirst(type)}`, { isLoading: loading }]" v-on="$listeners">
    <span class="baseButton__content"><slot /></span>
  </button>
</template>
<style lang="scss">
$colors: (
  'primary': (
    $color-primary,
    // color
      $color-primary-hover,
    // color hover
      #fff,
    // text color,,,
  ),
  'dark': (
    #c6c6ba,
    darken($color-text-dark, 10%),
    $color-text-dark,
  ),
  'light': (
    #ffffff,
    #c0c4cc,
    $color-primary,
  ),
  'facebook': (
    #c6c6ba,
    #4267b2,
    $color-text-dark,
  ),
);

.baseButton {
  display: inline-block;
  width: auto;
  // padding: 1.3rem 2.8rem;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.15;
  color: #fff;
  text-align: center;
  text-decoration: none !important;
  letter-spacing: 0.2em;
  white-space: nowrap;
  cursor: pointer;
  background: grey;
  border: none;
  opacity: 1;
  transition: background 0.3s, border 0.3s, color 0.3s, opacity 0.3s, box-shadow 0.3s;
  text-transform: uppercase;
  width: 288px;
  max-width: 100%;
  padding: 1.125rem 20px;
  // max-height: 50px;
  &:focus {
    outline: none;
  }
  &:disabled,
  &.isLoading {
    opacity: 0.5;
  }
  &:disabled {
    cursor: not-allowed;
  }
  &.isLoading {
    cursor: wait;
  }
  @include max-sm {
    font-size: 0.88rem;
    padding: 0.875rem 1.5rem;
  }
  &.isStylePrimary {
    background: $color-primary;
    color: $color-white;
    border-radius: 30px;
    // padding: 1.125rem 4rem;
    &:hover:not(:disabled),
    &:focus:not(:disabled) {
      box-shadow: 3px 7px 25px $color-primary;
    }
    &.isLight {
      background: #ff8127;
    }
  }
  &.isStyleTransparant {
    background: transparent;
    &:hover:not(:disabled),
    &:focus:not(:disabled) {
      box-shadow: 3px 7px 25px $color-primary;
      color: #fff;
    }
  }
  &.isStyleLight {
    background: $color-white;
    color: $color-primary;
    border-radius: 26px;
    // padding: 1rem 3.1rem;
    box-shadow: 3px 5px 15px $color-primary;
    &:hover:not(:disabled),
    &:focus:not(:disabled) {
      box-shadow: 3px 7px 25px $color-primary;
    }
    &.isPrimary {
      box-shadow: 3px 5px 15px $color-primary;
      background: $color-primary;
      color: $color-white;
    }
  }
  &.isStyleBorder {
    background: $color-white;
    color: $color-text-2;
    border-radius: 10px;
    // padding: 0.8125rem 7.93rem;
    border: 1px solid $color-text-2;
    transition: 0.3s;
    &:hover {
      color: $color-primary;
      border: 1px solid $color-primary;
    }
  }
  &.isLong {
    // padding: 1rem 5.8rem;
  }
  &.isBorder {
    border: 1px solid $color-white;
  }
  &.isSmall {
    width: 200px;
  }
  &.isMedium {
    width: 258px;
  }
  &.isRadius {
    border-radius: 30px;
  }
  &.isMobileFull {
    @include max-lg {
      width: 100%;
    }
  }
  // @each $color, $value in $colors {
  //   &.isStyle#{capitalize($color)} {
  //     color: nth($value, 3);
  //     background: nth($value, 1);
  //     &:hover:not(:disabled), &:focus:not(:disabled) {
  //       background: nth($value, 2);
  //       box-shadow: 3px 5px 15px nth($value, 3);;
  //     }
  //     &:active:not(:disabled) {
  //       background: darken(nth($value, 2), 10%);
  //     }
  //     &.isActive:not(:disabled) {
  //       color: #fff;
  //       background: nth($value, 2);
  //     }
  //     &.isOutline {
  //       color: nth($value, 1);
  //       border: 1px solid nth($value, 1);
  //       &:hover:not(:disabled), &:focus:not(:disabled) {
  //         color: #fff;
  //         background: nth($value, 2);
  //         border: 1px solid nth($value, 2);
  //       }
  //     }
  //   }
  // }

  // &.isStyleLink {
  //   padding: 0 0.5rem 0.25rem;
  //   background: transparent;
  //   color: $color-text-dark;
  //   border-bottom: 1px solid;
  //   font-size: 0.875rem;
  //   &:hover:not(:disabled), &:focus:not(:disabled) {
  //     border-bottom: 1px solid;
  //   }
  //   &.isDanger {
  //     &:hover:not(:disabled), &:focus:not(:disabled) {
  //       color: $color-danger
  //     }
  //   }
  // }

  // &.isRadius {
  //   border-radius: 26px;
  // }
  // &.isFillet {
  //   border-radius: 9527px;
  // }
  // &.isOutline {
  //   background: transparent;
  //   &:hover:not(:disabled) {
  //     color: #fff;
  //   }
  // }

  &.isFull {
    width: 100%;
  }
  &.isSmallRadious {
    border-radius: 10px;
  }

  &.isDingBeauty {
    border: 1px solid #e3c192;
    border-radius: 0;
    background-color: #e3c192 !important;
    color: #fff;
    box-shadow: none;
  }

  &.isDingBeauty-outline {
    border: 1px solid #e3c192;
    border-radius: 0;
    background-color: #fff !important;
    color: #e3c192;
    box-shadow: none;
  }

  .email-icon {
    width: 19px;
    margin-right: 8px;
  }
  // &.isCol1 {
  //   width: 120px;
  // }
  // &.isCol2 {
  //   width: 200px;
  // }
  // &.isCol3 {
  //   width: 452px;
  // }
  // &.isCol4 {
  //   width: 617px;
  // }
  // &.isLong {
  //   width: auto;
  //   padding: 1.3rem 3.8rem;
  // }
  // &.isSmall {
  //   width: auto;
  //   padding: 0.9rem 1.75rem;
  // }
  // &.isCircle {
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   width: 56px;
  //   height: 56px;
  //   padding: 0;
  //   padding-left: 2px;
  //   border: unset;
  //   border-radius: 100%;
  // }
  // &.isShadow {
  //   box-shadow: rgb(0 0 0 / 15%) 0px 4px 12px 0px;
  // }
  // &.isLoading {
  //   position: relative;
  //   pointer-events: none;
  //   .baseButton__content {
  //     opacity: 0;
  //   }
  //   &::after {
  //     position: absolute;
  //     top: calc(50% - .6em);
  //     left: calc(50% - .6em);
  //     display: block;
  //     width: 1.2em;
  //     height: 1.2em;
  //     content: "";
  //     border: 2.5px solid;
  //     border-top-color: transparent;
  //     border-right-color: transparent;
  //     border-radius: 290486px;
  //     animation: spinAround 0.6s infinite linear;
  //   }
  // }
}

@keyframes spinAround {
  0% {
    transform: rotate(0turn);
  }
  100% {
    transform: rotate(1turn);
  }
}
</style>
